var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7283_39502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0.521719 12 12 10.4348 12 10.4348L24 12Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7633 8.28018L12.0001 13.0435L7.23683 8.28018C6.62085 9.19457 6.26099 10.2952 6.26099 11.4782V13.0434C6.26099 15.5567 7.88497 17.6976 10.1386 18.4725C9.83778 19.062 9.8885 19.7977 10.3293 20.3478C10.9146 19.8786 11.5207 19.3929 12.0348 18.981C12.5489 19.393 13.155 19.8787 13.7404 20.3478C14.1863 19.7913 14.2333 19.0446 13.9207 18.4516C16.1435 17.6599 17.7392 15.5347 17.7392 13.0434V11.4783C17.7392 10.2952 17.3793 9.19462 16.7633 8.28018Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 17.2174C9.69855 17.2174 7.82617 15.345 7.82617 13.0435V11.4783C7.82617 9.17677 9.69859 7.3044 12.0001 7.3044C14.3015 7.3044 16.174 9.17682 16.174 11.4783V13.0435C16.174 15.345 14.3016 17.2174 12.0001 17.2174Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 13.0435V11.4783C14.6087 10.0398 13.4385 8.8696 12 8.8696C10.5616 8.8696 9.39136 10.0399 9.39136 11.4783V13.0435L12 13.5652L14.6087 13.0435Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39136 13.0435C9.39136 14.4819 10.5616 15.6522 12 15.6522C13.4385 15.6522 14.6087 14.4819 14.6087 13.0435H9.39136Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1305 7.30435C15.1305 6.43993 14.4297 5.73914 13.5653 5.73914C13.1643 5.73914 12.7988 5.89008 12.5218 6.138V5.21738H13.0435V4.17389H12.5218V3.65218H11.4783V4.17389H10.9566V5.21738H11.4783V6.138C11.2013 5.89008 10.8358 5.73914 10.4348 5.73914C9.57041 5.73914 8.86963 6.43993 8.86963 7.30435C8.86963 7.7678 9.07124 8.18405 9.39135 8.47069V9.39132H14.6087V8.47069C14.9289 8.18405 15.1305 7.7678 15.1305 7.30435Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7283_39502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/sm.63010a675d7498595a30e2647b9dd5a9.svg";
export { ForwardRef as ReactComponent };